export default __webpack_public_path__ + "static/media/icon-close.8ab6beb4.svg";